import { apiClient, fetcher } from './apiClient';
import type { PaginatedResponse } from './Pagination';

type AdminDeviceOrg = {
    id: string;
    name: string;
};

type AdminDeviceTag = {
    id: string;
    label: string;
};

type AdminDeviceLocation = {
    id: string;
    name: string;
};

type AdminDevice = {
    id: string;
    name: string | null;
    orgId: string | null;
    org: AdminDeviceOrg | null;
    location: AdminDeviceLocation | null;
    deviceTags: AdminDeviceTag[];
};

type MigrateSummary = {
    contentStrategy: 'moved' | 'cloned' | 'none';
    devices: number;
    locationsCloned: number;
    deviceTagsCloned: number;
    playlists: number;
    scenes: number;
    components: number;
    locationsDeleted: number;
    deviceTagsDeleted: number;
    deviceConfigs: number;
    devicePings: number;
};

type MigrateDeviceResponse = {
    devices: AdminDevice[];
    summary: MigrateSummary;
};

const jsonHeaders = (csrfToken: string | null) => ({
    'Content-Type': 'application/json',
    'X-XSRF-TOKEN': csrfToken ?? '',
});

const listAdminDevices = async (url: string): Promise<PaginatedResponse<AdminDevice>> =>
    fetcher<PaginatedResponse<AdminDevice>>(url);

const migrateAdminDevices = async (
    csrfToken: string | null,
    deviceIds: string[],
    destOrgId: string,
): Promise<MigrateDeviceResponse> => {
    if (csrfToken === null) {
        throw new Error('CSRF token is required');
    }

    const response = await apiClient.post(
        'api/admin/devices/migrate',
        JSON.stringify({ deviceIds, destOrgId }),
        { headers: jsonHeaders(csrfToken) },
    );

    return JSON.parse(response.data) as MigrateDeviceResponse;
};

export { listAdminDevices, migrateAdminDevices };
export type {
    AdminDevice,
    AdminDeviceLocation,
    AdminDeviceOrg,
    AdminDeviceTag,
    MigrateDeviceResponse,
    MigrateSummary,
};
